<!-- 调拨商品信息 -->
<template>
    <div class="page-content">
        <c-header pageName="调拨商品信息"></c-header>
        <div class="goods-list">
            <div class="receive-item flex" v-for="(item,index) in goodsList" :key="index">
                <section>商品名称 : {{item.goodsName}}</section>
                <section>国际条码 : {{item.goodsBarCode}}</section>
                <section>板号 : {{item.bandSn}}</section>
                <section>数量 : {{item.qty}}</section>
                <section>项次 : {{item.itemSn}}</section>
                <section>商品状态 : {{item.defectFlag ? "不良品" : "良品"}}</section>
                <section>库位 : {{item.storageLocationName}}</section>
                <section class="button-tool">
                    <!-- <span>打印</span>  -->
                    <label style="background-color:#9AC0CD;">打印</label>
                </section>
                <div class="item-content"></div>
                <!-- <div class="item-icon" @click="onAllocateSub(item.id)">
                    <span>确认</span>
                </div>-->
            </div>
        </div>
    </div>
</template>

<script >
import Header from "../components/headerNav.vue";
export default {
    data() {
        return {
            id: "", // 明细Id
            goodsList: []
        };
    },
    components: {
        "c-header": Header
    },
    mounted() {
        this.id = this.$route.query.id;
        if (this.id) {
            this.allocateSub();
        }
        //this.getGoodsList();
    },
    methods: {
        // 处理调拨明细确认
        allocateSub() {
            this.$post(this.URL.allocateDetailSub, { id: this.id }).then(
                res => {
                    if (res.success) {
                        this.goodsList = res.data;
                    } else {
                        this.$toast.fail(res.message);
                    }
                }
            );
        },
        // 获取调拨单商品
        getGoodsList() {
            this.$post(this.URL.allocateGoods, { id: this.id }).then(res => {
                if (res.success) {
                    this.goodsList = res.data;
                } else {
                    this.$toast.fail(res.message);
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped >
.page-content {
    height: 100vh;
    align-content: flex-start;
}

.goods-list {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    padding: 1rem 0.5rem;
    font-size: 0.85rem;
    padding: 0.5rem 0.8rem;
    color: #444;
    .receive-item {
        padding: 0.5rem 0;
        border-bottom: 1px dashed #eee;
        flex-wrap: wrap;
        section {
            display: flex;
            width: 100%;
            line-height: 1.2rem;
            span {
                display: inline-flex;
                margin-right: 0.5rem;
                height: 1.8rem;
                align-items: center;
                padding: 0 0.8rem;
                background-color: #dc6350;
                border-radius: 0.2rem;
                color: white;
            }
        }
        .button-tool {
            height: 2.5rem;
            align-items: center;
            label {
                display: inline-flex;
                margin-right: 0.5rem;
                height: 1.8rem;
                align-items: center;
                padding: 0 0.8rem;
                background-color: #dc6350;
                border-radius: 0.2rem;
                color: white;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/AllocateGoodsList.vue